import { createContext, useContext, useMemo } from 'react';
import type React from 'react';
import type { Vehicle } from '~/contracts';

type VehicleContextType = {
  vehicle: Partial<Vehicle>;
};

const defaultContext: VehicleContextType = {
  vehicle: {}
};

const VehicleContext = createContext<VehicleContextType>(defaultContext);

export function useVehicleContext() {
  return useContext(VehicleContext);
}

export const VehicleContextProvider: React.FC<{ vehicle?: Vehicle }> = ({
  children,
  vehicle = {}
}) => {
  const value = useMemo<VehicleContextType>(() => ({ vehicle }), [vehicle]);

  return (
    <VehicleContext.Provider value={value}>{children}</VehicleContext.Provider>
  );
};

export default VehicleContext;
